import { COMMA, ENTER } from '@angular/cdk/keycodes';
import {
   ChangeDetectionStrategy,
   Component,
   ElementRef,
   EventEmitter,
   Input,
   OnInit,
   Output,
   ViewChild,
   ViewEncapsulation,
} from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import { CallState } from '@lcs/shared/api';
import { ExtensionTypes } from 'generated/graphql-types';
import { ExtensionDetailView } from '../../extension-details/models/extension-detail-view.model';
import { AddFindMeFollowMeStepData } from '../../extension-details/views/extension-find-me-follow-me-sections/models/extension-find-me-follow-me-step.model';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-add-find-me-follow-me-step-view',
    styleUrls: ['./add-find-me-follow-me-step-view.component.scss'],
    templateUrl: './add-find-me-follow-me-step-view.component.html',
    standalone: false
})
export class AddFindMeFollowMeStepViewComponent implements OnInit {
   @ViewChild('tagsInput') tagsInput: ElementRef<HTMLInputElement>;

   @Input() callState: CallState;

   @Input() form: UntypedFormGroup;

   @Input() extension: ExtensionDetailView | null;

   @Input() title: string;

   @Input() accountId: number | null;

   @Output() formSubmitted = new EventEmitter<AddFindMeFollowMeStepData>();

   @Output() formCanceled = new EventEmitter<void>();

   phoneExtensionTypes = [ExtensionTypes.Phone];

   extensionIdsToExclude: number[] = [];

   searchControl = new UntypedFormControl('');

   separatorKeysCodes: number[] = [ENTER, COMMA];

   phoneNumbers: AbstractControl | null;

   ngOnInit() {
      this.phoneNumbers = this.form.get('extensionsOrPhoneNumbersToDial');
   }

   onCloseClick(): void {
      this.formCanceled.emit();
   }

   onCreate(): void {
      if (this.form.valid) {
         this.formSubmitted.emit();
      }
   }

   add(event: MatChipInputEvent): void {
      const value = event.value?.trim();
      this.phoneNumbers?.patchValue([...this.phoneNumbers.value, value]);
      this.phoneNumbers?.updateValueAndValidity();
      this.tagsInput.nativeElement.value = '';
   }

   removeValue(index: number): void {
      const values: any[] = [...this.phoneNumbers?.value];
      this.phoneNumbers?.patchValue([...values.slice(0, index), ...values.slice(index + 1, values.length)]);
      this.phoneNumbers?.updateValueAndValidity();
   }
}
